import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { FOOD_FREQ, FOOD_CNT, FOOD_ABNORMAL, FOOD_ACT, WATER, WATER_FREQ, WATER_ACT, FECAL, FECAL_FREQ, FECAL_ACT, FECAL_ABNORMAL, FECAL_COLOR, FECAL_VOL, URINE, URINE_VOL, URINE_COLOR, URINE_ABNORMAL, URINE_FREQ, MONITOR_ANES, MONITOR_FLUIDS, MONITOR_BREATH } from '../../../../environments/environment';

import Swal from 'sweetalert2';
import { CatalogService } from '../../../services/catalog.service';
import { PetEnvironmentModel } from '../../../models/pet-enviroment.model';

declare var $: any;

@Component({
  selector: 'ngx-work-profile-metabolic',
  templateUrl: './profile-metabolic.component.html',
})
export class ProfileMetabolicComponent implements OnInit {

  private _pet_no: number;
  FOOD_FREQ = FOOD_FREQ;
  FOOD_CNT = FOOD_CNT;
  FOOD_ABNORMAL = FOOD_ABNORMAL;
  FOOD_ACT = FOOD_ACT;
  WATER = WATER;
  WATER_FREQ = WATER_FREQ;
  WATER_ACT = WATER_ACT;
  FECAL = FECAL;
  FECAL_FREQ = FECAL_FREQ;
  FECAL_ACT = FECAL_ACT;
  FECAL_ABNORMAL = FECAL_ABNORMAL;
  FECAL_COLOR = FECAL_COLOR;
  FECAL_VOL = FECAL_VOL;
  URINE = URINE;
  URINE_VOL = URINE_VOL;
  URINE_COLOR = URINE_COLOR;
  URINE_ABNORMAL = URINE_ABNORMAL;
  URINE_FREQ = URINE_FREQ;
  MONITOR_ANES = MONITOR_ANES;
  MONITOR_FLUIDS = MONITOR_FLUIDS;
  MONITOR_BREATH = MONITOR_BREATH;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.petService.getMetabolicByPetId(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    public catalogService: CatalogService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
      });
  }

  save() {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    this.petService.setupPetMetabolic()
        .then(() => {
            Swal.close();

            Swal.fire({
              title: 'Information stored correctly',
              didOpen: () => {
              },
            })
        });
  }

}
